import React from 'react';
import { X } from 'lucide-react';
import Logo from '@/components/Logo';
import { useEstimator } from './context';
import ProgressIndicator from './ProgressIndicator';
import styles from './ProjectEstimator.module.scss';

export const EstimatorHeader: React.FC = () => {
  const { closeEstimator, estimate, selections } = useEstimator();

  return (
    <header className={styles.header}>
      <div className={styles.headerTop}>
        {/* Left: Brand */}
        <div className={styles.headerLeft}>
          <Logo variant="estimator" onClick={closeEstimator} ariaLabel="Arkatechs Home" />
        </div>

        {/* Center: Title & live estimate badge */}
        <div className={styles.headerCenter}>
          <span className={styles.headerTitle}>PROJECT ESTIMATOR</span>
          {selections.selectedServices.length > 0 && (
            <div className={styles.liveBadge} title="Starting price based on selected services">
              <span className={styles.liveBadgeDot} />
              <span className={styles.liveBadgeText}>FROM {estimate.formattedTotal}</span>
            </div>
          )}
        </div>

        {/* Right: Close button */}
        <div className={styles.headerRight}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={closeEstimator}
            aria-label="Close project estimator"
            id="estimator-close-button"
          >
            <span className={styles.closeLabel}>CLOSE</span>
            <X size={18} />
          </button>
        </div>
      </div>

      {/* Step Indicator */}
      <ProgressIndicator />
    </header>
  );
};

export default EstimatorHeader;
